import React, { useEffect, useRef, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import chooseImg from "../assets/choose-image.jpg";
import "../styles/ChooseTanbio.css";

/* ─────────────────────────────────────────────
   WhatsApp number — same as Navbar contact number
   (73587 98182) prefixed with India country code
───────────────────────────────────────────── */
const WHATSAPP_NUMBER = "917358798182";

function openWhatsApp(message) {
  const url = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
    message
  )}`;
  window.open(url, "_blank", "noopener,noreferrer");
}

const features = [
  {
    icon: "fa-solid fa-shield-halved",
    color: "#25B5E9",
    title: "NABL Quality Assured",
    sub: "All tests performed as per NABL standards",
  },
  {
    icon: "fa-regular fa-clock",
    color: "#0A4D9C",
    title: "Quick & Accurate",
    sub: "Timely reports with highest accuracy",
  },
  {
    icon: "fa-solid fa-laptop-medical",
    color: "#0A4D9C",
    title: "Advanced Equipment",
    sub: "Latest technology and automated systems",
  },
  {
    icon: "fa-solid fa-user-group",
    color: "#e85d8a",
    title: "Experienced Team",
    sub: "Qualified pathologists & trained professionals",
  },
  {
    icon: "fa-solid fa-house-medical",
    color: "#25B5E9",
    title: "Home Sample Collection",
    sub: "Safe and hygienic sample collection at your doorstep",
  },
];

export default function ChooseTanbio() {
  const sectionRef = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.08 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  function handleBookTest() {
    openWhatsApp(
      "Hi, I'd like to book a test at TANBIO Biomed Genomics Laboratory. Please share the available slots."
    );
  }

  function handleScheduleCollection() {
    openWhatsApp(
      "Hi, I'd like to schedule a home sample collection. Please share the available slots."
    );
  }

  return (
    <section
      className={`ctb-section${visible ? " ctb-visible" : ""}`}
      ref={sectionRef}
    >
      <Container fluid className="ctb-container px-4 px-lg-5">

        {/* ── CARD 1: Why Choose ── */}
        <div className="ctb-why-card">
          <h2 className="ctb-why-heading">WHY CHOOSE TANBIO?</h2>
          <div className="ctb-features-row">
            {features.map((f, i) => (
              <div
                className="ctb-feature-item"
                key={f.title}
                style={{ animationDelay: `${0.1 + i * 0.1}s` }}
              >
                <div
                  className="ctb-feature-icon-wrap"
                  style={{ borderColor: f.color, color: f.color }}
                >
                  <i className={f.icon}></i>
                </div>
                <div className="ctb-feature-text">
                  <span className="ctb-feature-title">{f.title}</span>
                  <span className="ctb-feature-sub">{f.sub}</span>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* ── CARD 2: CTA Banner ── */}
        <div className="ctb-cta-card">
          {/* Left image */}
          <div className="ctb-cta-img-wrap" aria-hidden="true">
            <img src={chooseImg} alt="Lab professional" loading="lazy" className="ctb-cta-img" />
          </div>

          {/* Center text */}
          <div className="ctb-cta-body">
            <div className="ctb-cta-icon-wrap" aria-hidden="true">
              <i className="fa-regular fa-calendar-check"></i>
            </div>
            <div className="ctb-cta-text">
              <h3 className="ctb-cta-heading">Need a Test Done?</h3>
              <p className="ctb-cta-desc">
                Book your test or schedule a home collection in just a few clicks.
              </p>
            </div>
          </div>

          {/* Right buttons */}
          <div className="ctb-cta-actions">
            <button
              type="button"
              className="ctb-btn-primary"
              onClick={handleBookTest}
            >
              <i className="fa-brands fa-whatsapp me-2"></i>
              Book a Test Now
            </button>
            <button
              type="button"
              className="ctb-btn-outline"
              onClick={handleScheduleCollection}
            >
              <i className="fa-solid fa-house-medical"></i>
              Schedule Collection
            </button>
          </div>
        </div>

      </Container>
    </section>
  );
}